import React from 'react';
import { Box, Paper } from '@mui/material';

/**
 * UI-CONSISTENCY.1 — the ONE filter-bar container.
 *
 * The Reports idiom generalized: filters live in a Paper card, wrapping
 * gracefully; an optional actions row underneath holds left-anchored controls
 * (e.g. the Columns menu) and right-aligned primary actions (Run, exports).
 * Carries no outer margins — spacing comes from the standard page root's gap.
 */

interface FilterBarProps {
  /** Filter controls (selects, date pickers, search fields). */
  children: React.ReactNode;
  /** Right-aligned actions row content (Run, export buttons). */
  actions?: React.ReactNode;
  /** Left-anchored actions row content (e.g. ColumnVisibilityMenu). */
  actionsLeft?: React.ReactNode;
}

const FilterBar: React.FC<FilterBarProps> = ({ children, actions, actionsLeft }) => (
  <Paper sx={{ p: 2, borderRadius: 2 }}>
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, alignItems: 'flex-start' }}>
      {children}
    </Box>
    {(actions || actionsLeft) && (
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 2, alignItems: 'center' }}>
        {actionsLeft}
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, ml: 'auto' }}>
          {actions}
        </Box>
      </Box>
    )}
  </Paper>
);

export default FilterBar;
